/** Hand the browser back to the AI client (with a code or an error). */
export function leaveTo({ redirectUrl }: { redirectUrl: string }): void {
  window.location.assign(redirectUrl);
}
